import { Link } from "@tanstack/react-router";
import type { CSSProperties } from "react";

import { PremiumUpgradePopover } from "#/components/PremiumUpgradePopover";
import { Button } from "#/components/ui/button";
import { mapAccessUiFlags, type AccessResult } from "#/lib/mapAccessUi";
import { isMapAccessUpsellReason, mapAccessUpsellCopy } from "#/lib/mapAccessUpsellCopy";
import { cn } from "#/lib/utils";

type PlayMapCtaLink = { to: "/play/$mapId"; params: { mapId: string } } | { to: "/challenge" };

export function PlayMapCta({
  mapId,
  access,
  label = "Play →",
  className,
  style,
  playLink,
}: {
  mapId: string;
  access: AccessResult;
  label?: string;
  className?: string;
  style?: CSSProperties;
  playLink?: PlayMapCtaLink;
}) {
  const { canPlay, isUpgradeLocked } = mapAccessUiFlags(access);
  const buttonClassName = cn("mx-auto h-11 w-full text-base font-semibold shadow-md", className);
  const link = playLink ?? { to: "/play/$mapId" as const, params: { mapId } };

  if (canPlay) {
    return (
      <Button
        size="lg"
        className={buttonClassName}
        style={style}
        render={<Link {...link} preload={false} />}
        nativeButton={false}
      >
        {label}
      </Button>
    );
  }

  if (isUpgradeLocked && !access.ok && isMapAccessUpsellReason(access.reason)) {
    return (
      <PremiumUpgradePopover
        triggerLabel={label}
        description={mapAccessUpsellCopy(access.reason, mapId).description}
        className={buttonClassName}
        style={style}
      />
    );
  }

  return <p className="w-full text-center text-sm text-muted-foreground">Not yet released</p>;
}
